import React from 'react';
import Gallery from '../grid-gallery';
import './index.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

const About = () => (
    <div id="about-nav" className="about-container">
        <div data-aos="fade-up" data-aos-duration="1000" className="about-item">
            <h3>About Us</h3>
            <h2>Helping Businesses<br />Stay Compliant With All<br />Foam Proportioner Testing</h2>
            <div className="since-container">
                <h6>Since 2006</h6>
                <div className="seperator" />
            </div>
            <p><span className="bold">Foam Solutions</span> offers the most cost effective, environmentally friendly solution to your annual foam proportioner testing. Not to mention saving our enviornment from foam containiments.</p>
            <a href="#">More Details</a>
        </div>
        <div data-aos="fade-up" data-aos-duration="1500" className="about-item">
            <Gallery />
        </div>
    </div>
)
export default About;